import type { IssueWorkflowOutDto } from 'shared/domain/workflow/types';
import db from '..';
import {
  makeDefaultAddBatch,
  makeDefaultCount,
  makeDefaultGetMany,
  makeDefaultRemoveBatch,
} from '../defaultDaoFactories';
import { entityDbClearFactory } from '../entityDbClearFactory';
import { clear as issueWorkflowsServiceClear } from './issueWorkflowsService';
import { workflowContract } from 'shared/domain/workflow/workflowContract';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';

export const clear = entityDbClearFactory(
  db,
  ['issueWorkflows', 'issueWorkflowsService'],
  () => db.issueWorkflows.clear(),
  issueWorkflowsServiceClear,
  makeClearPublisher(workflowContract)
);

export const quantity = makeDefaultCount<IssueWorkflowOutDto>(
  db,
  db.issueWorkflows
);

export const get = makeDefaultGetMany<IssueWorkflowOutDto>(
  db,
  db.issueWorkflows
);

export const addBatch = makeDefaultAddBatch<IssueWorkflowOutDto>(
  db,
  db.issueWorkflows
);

export const updateBatch = addBatch;

export const removeBatch = makeDefaultRemoveBatch<
  string,
  IssueWorkflowOutDto
>(db, db.issueWorkflows, '_id');
